var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    zoomAndPan: "magnify",
    viewBox: "0 0 75 74.999997",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 66.246094 35.007812 L 22.425781 35.007812 C 21.050781 35.007812 19.933594 36.125 19.933594 37.5 C 19.933594 38.875 21.050781 39.992188 22.425781 39.992188 L 66.246094 39.992188 L 55.546875 50.6875 C 54.574219 51.660156 54.574219 53.238281 55.546875 54.210938 C 56.519531 55.183594 58.097656 55.183594 59.070312 54.210938 L 74.019531 39.261719 C 74.996094 38.289062 74.996094 36.710938 74.019531 35.738281 L 59.070312 20.789062 C 58.097656 19.816406 56.519531 19.816406 55.546875 20.789062 C 54.574219 21.761719 54.574219 23.339844 55.546875 24.3125 Z M 66.246094 35.007812 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 44.851562 17.566406 L 44.851562 7.601562 C 44.851562 3.472656 41.503906 0.125 37.375 0.125 L 7.476562 0.125 C 3.347656 0.125 0 3.472656 0 7.601562 L 0 67.398438 C 0 71.527344 3.347656 74.875 7.476562 74.875 L 37.375 74.875 C 41.503906 74.875 44.851562 71.527344 44.851562 67.398438 C 44.851562 67.398438 44.851562 57.433594 44.851562 57.433594 C 44.851562 56.058594 43.734375 54.941406 42.359375 54.941406 C 40.984375 54.941406 39.867188 56.058594 39.867188 57.433594 L 39.867188 67.398438 C 39.867188 68.777344 38.75 69.890625 37.375 69.890625 C 37.375 69.890625 7.476562 69.890625 7.476562 69.890625 C 6.101562 69.890625 4.984375 68.777344 4.984375 67.398438 L 4.984375 7.601562 C 4.984375 6.222656 6.101562 5.109375 7.476562 5.109375 C 7.476562 5.109375 37.375 5.109375 37.375 5.109375 C 38.75 5.109375 39.867188 6.222656 39.867188 7.601562 L 39.867188 17.566406 C 39.867188 18.941406 40.984375 20.058594 42.359375 20.058594 C 43.734375 20.058594 44.851562 18.941406 44.851562 17.566406 Z M 44.851562 17.566406 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.17a94c43d0b1d13e41d1d1a460da42d7.svg";
export { ForwardRef as ReactComponent };